import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hiv/positive_result.png'
import _imports_1 from '@/assets/hiv/negative_result.png'
import _imports_2 from '@/assets/hiv/invalid_one_line_result.png'
import _imports_3 from '@/assets/hiv/invalid_no_line_result.png'


const _withScopeId = n => (_pushScopeId("data-v-09f75c53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "TestInstructionsStepFive" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info" }, " Clique na imagem que mais se parece com o resultado que você vê no seu autoteste. ", -1))
const _hoisted_3 = { class: "result-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container w-100 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "result-image",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container w-100 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "result-image",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "d-flex justify-content-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container w-100 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "result-image",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container w-100 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "result-image",
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = { class: "error-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-span open-sans-font" }, " Campo de preenchimento obrigatório, selecione uma opção.", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_timer_confirmation_modal = _resolveComponent("timer-confirmation-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "5",
      stepTitle: this.StepContent.title,
      nextButtonActive: _ctx.canJumpNext,
      onNextStep: _cache[4] || (_cache[4] = ($event: any) => (
        _ctx.registerTestStore.resultTest
          ? this.$refs['timer-confirmation-modal'].toggleModal(true)
          : this.$emit('nextStep')
      )),
      onPreviousStep: _cache[5] || (_cache[5] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_alert_box, {
          class: "px-3 mt-8 mb-24",
          info: "",
          stepContent: _ctx.StepContent
        }, null, 8, ["stepContent"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio left-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result", {
                checked:
                  _ctx.registerTestStore.resultTest == _ctx.results.positive.result,
                'has-error': _ctx.hasError,
              }])
            }, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("input", {
                  class: "hide-radio",
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setResultTest(_ctx.results.positive)))
                }, null, 32),
                _createElementVNode("span", {
                  for: "positive-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked:
                      _ctx.registerTestStore.resultTest == _ctx.results.positive.result,
                  }])
                }, "Positivo", 2)
              ])
            ], 2)
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio right-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result double-image", {
                checked:
                  _ctx.registerTestStore.resultTest == _ctx.results.negative.result,
                'has-error': _ctx.hasError,
              }])
            }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("input", {
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setResultTest(_ctx.results.negative)))
                }, null, 32),
                _createElementVNode("span", {
                  for: "negative-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked:
                      _ctx.registerTestStore.resultTest == _ctx.results.negative.result,
                  }])
                }, "Negativo", 2)
              ])
            ], 2)
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio right-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result double-image", {
                checked:
                  _ctx.registerTestStore.resultTest ==
                  _ctx.results.invalid_one_line.result,
                'has-error': _ctx.hasError,
              }])
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setResultTest(_ctx.results.invalid_one_line)))
                }, null, 32),
                _createElementVNode("span", {
                  for: "invalid_one_line-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked:
                      _ctx.registerTestStore.resultTest ==
                      _ctx.results.invalid_one_line.result,
                  }])
                }, "Inválido", 2)
              ])
            ], 2)
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio right-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["option-result double-image", {
                checked:
                  _ctx.registerTestStore.resultTest ==
                  _ctx.results.invalid_no_line.result,
                'has-error': _ctx.hasError,
              }])
            }, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("input", {
                  name: "covid-result",
                  type: "radio",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setResultTest(_ctx.results.invalid_no_line)))
                }, null, 32),
                _createElementVNode("span", {
                  for: "invalid_no_line-result",
                  class: _normalizeClass(["open-sans-font hide-radio", {
                    checked:
                      _ctx.registerTestStore.resultTest ==
                      _ctx.results.invalid_no_line.result,
                  }])
                }, "Inválido", 2)
              ])
            ], 2)
          ], 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_14, 512), [
          [_vShow, _ctx.hasError]
        ])
      ]),
      _: 1
    }, 8, ["stepTitle", "nextButtonActive"]),
    _createVNode(_component_timer_confirmation_modal, {
      ref: "timer-confirmation-modal",
      onNextStep: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('nextStep')))
    }, null, 512)
  ]))
}